var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupeu476(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 562.394,
    height: 417.709,
    viewBox: "0 0 562.394 417.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d9cfff;}.b{fill:#22204a;}.c{fill:#d7e8f4;}.d{fill:#eac5b0;}.e{fill:#2a348a;}.f{fill:#f57089;}.g{fill:#e4647f;}.h{fill:#1e1e1e;}.i{fill:#fbfbfb;}.j{fill:#212148;}.k{fill:#fdc9b1;}.l{fill:#d2c3a8;}.m{fill:none;}.n{fill:#4b505b;}.o{fill:#bec0c1;}.p{fill:#3b455a;}.q{fill:#5764de;}.r{fill:#fff;}.s{fill:#392a8d;}.t{fill:#587bc9;}.u{fill:#e2ac91;}.v{fill:#23204a;}.w{fill:#305399;}.x{fill:#1a3151;}.y{fill:#f7f7f7;}.z{fill:#dae5ea;}.aa{fill:#edeeef;}.ab{opacity:0.16;mix-blend-mode:multiply;isolation:isolate;}.ac{fill:#191740;}.ad{fill:#6d6e71;}.ae{fill:#73726f;}.af{fill:#afadac;}.ag{fill:#364bc3;}.ah{fill:#3f49c5;}.ai{fill:#f4f5f5;}.aj{fill:#ebeaeb;}.ak{fill:#868381;}.al{fill:#94908b;}.am{fill:#5d5a59;}.an{fill:#bcbec0;}.ao{fill:#f6708a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.695 -19.648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M311.513,714.842c-16.045.029-32.091.265-48.107,1.354-6.039.41-11.951,1.314-18,1.678-12.09.728-23.964,2.086-36.1,2.712-9.771.5-19.582.8-29.325,1.442a168.16,168.16,0,0,1-28.309-.529c-6.71-.734-13.45-1.147-20.048-2.326a130.545,130.545,0,0,0-23.087-2.227c-10.965.048-21.643.054-32.136,2.382-3.684.817-8.193,2.16-10.99,3.875-6.4,3.926-7.27,13.722-.877,17.794,10.769,6.853,33.752,9.542,48.847,9.669,16.54.139,32.608-.612,49.173-1.053,15.392-.41,30.745-.994,46.163-.974,31.489.042,62.982,0,94.414-1.286,29.531-1.208,59.136-.793,88.732-.793,30.349,0,60.494.146,90.624,2.612,13.128,1.074,26.5,1.451,39.7,2.2,11.817.675,23.171-.013,34.941-.637a127.28,127.28,0,0,0,28.679-4.7c7.107-2.076,19.776-8.528,21.956-13.485,6.11-13.9-86.109-13.563-100.268-13.532-15.84.035-31.805.354-47.632-.016a179.536,179.536,0,0,1-19.715-1.822c-6.472-.868-12.993-.648-19.557-1.012-27.37-1.522-54.8-1.3-82.259-1.3C329.393,714.874,320.453,714.826,311.513,714.842Z",
    transform: "translate(-11.96 -314.296)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.071 200.763)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M171.533,391.025l14.735-15.179,5.809-24.781,3.245-.855-17.961,2.531-4.126,9.516-23.87,29.076.048.174C156.786,392.1,164.159,389.948,171.533,391.025Z",
    transform: "translate(-149.365 -350.21)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(386.433 206.556)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M677.5,360.784l33.529,23.584,22.051,19.517-9.408,1.434-43.457-29.111Z",
    transform: "translate(-677.496 -360.784)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.482 19.648)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M520.7,138.566a4.814,4.814,0,0,0-.222-1.423,5.715,5.715,0,0,0-1.243-2.067c-1.391-1.553-3.489-2.232-5.466-2.907a17.756,17.756,0,0,1-5.947-2.987c-3.226-2.759-2.13-6.976-4.371-10.211a5.167,5.167,0,0,0-5.432-2.427L486.658,85.178l2.092-.508c.982-.238,4.857-2.31,4.58-3.451l-.01-.042a1.994,1.994,0,0,0-2.279-1.633l-.821.2a1.524,1.524,0,0,0-.012-.667l-.007-.03a1.542,1.542,0,0,0-1.866-1.13l-3.96.961-1.792-4.945,4.269-1.037a1.542,1.542,0,0,0,1.139-1.86l-.007-.03a1.543,1.543,0,0,0-1.866-1.131l-1.379.335L490.978,50.3a2.737,2.737,0,0,0-2.75-3.243l-7.607.141c-1.182.022-2.359.09-3.533.2l-.065-.267a2.937,2.937,0,0,0-3.552-2.153l-.145.036-1.685-3.288,6.66-1.617a1.661,1.661,0,0,0,1.227-2l-1.781-7.334a1.661,1.661,0,0,0-2.009-1.217l-5.721,1.389-.677-7.368a1.007,1.007,0,0,0-.5-.781l-5.269-3.013a1.017,1.017,0,0,0-1.357.33l-3.3,5.093a1,1,0,0,0-.089.924l2.777,6.858-5.721,1.389a1.661,1.661,0,0,0-1.227,2l1.781,7.334a1.661,1.661,0,0,0,2.009,1.217l6.66-1.617.01,3.7-.105.026a2.936,2.936,0,0,0-2.169,3.541l.053.217q-1.93.773-3.8,1.705l-6.3,3.153a2.737,2.737,0,0,0-.942,4.135L466.123,74.73l-1.426.346a1.543,1.543,0,0,0-1.14,1.86l.007.03a1.543,1.543,0,0,0,1.866,1.13l4.057-.985.748,5.2-3.322.807a1.542,1.542,0,0,0-1.14,1.86l.007.03a1.519,1.519,0,0,0,.3.6l-.388.094a1.994,1.994,0,0,0-1.277,2.5l.01.042c.277,1.14,4.556,1.233,5.538.994l1.228-.3,4.683,32.535a5.567,5.567,0,0,0-3.643,4.628c-.508,3.9,2.4,7.147.8,11.079a17.766,17.766,0,0,1-3.915,5.381c-1.448,1.507-3,3.072-3.525,5.089a5.421,5.421,0,0,0,.371,4.2,5.206,5.206,0,0,0-2.752,5.883l.025.1a5.215,5.215,0,0,0,6.307,3.822l52.425-12.728a5.215,5.215,0,0,0,3.853-6.288l-.025-.1A5.2,5.2,0,0,0,520.7,138.566Z",
    transform: "translate(-451.266 -19.648)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.675 150.907)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M519.395,274.28l4.17-7.357-3.881-7.707-4.194,2.144.41,6.293-2.226,2.108.772,5.4Z",
    transform: "translate(-513.673 -259.216)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(275.05 164.956)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M474.2,326.069l25.015-1.408-4.013-38.238,8.767-1.566,9.246,49.157-9.483,8.649-25.5,3.156Z",
    transform: "translate(-474.205 -284.857)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.695 98.704)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M255.2,163.938l-66.942,6.3L200.8,188.625c-20.242,14.242-45.569,32.141-46.327,33.067-1.266,1.548-11.648-35.344-11.648-35.344L89.073,227.6,76.689,203.019,33.695,236.4l37.483-16.621L84.9,246.556l47.664-33.5,10.744,38.167,69.88-44.446,13.486,19.765Z",
    transform: "translate(-33.695 -163.938)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.539 39.295)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M233.621,283.733l70.811-43.427-2.683-4.648Z",
    transform: "translate(-233.621 -235.658)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.245 48.413)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M127.225,286.263l48.9-28.958L174.7,252.3Z",
    transform: "translate(-127.225 -252.298)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.291 55.611)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M71.552,265.437,34.226,282.244,72.975,268.7Z",
    transform: "translate(-34.226 -265.437)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.888 152.883)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M327.693,279.022l-1.137-11.162-7.456-5.037-2.153,6.012,3.56,6.841v5.6Z",
    transform: "translate(-316.946 -262.822)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(153.246 350.985)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.359 54.378)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M276.358,732.777l-7.812-7.216a15.385,15.385,0,0,0-6.608-1.923,3.738,3.738,0,0,0-3.288,1.541,3.787,3.787,0,0,0-.354,3.48,4.719,4.719,0,0,0,.679,1.1h0l0,0c.233.291.487.567.741.839.162.174.339.36.529.554a44.884,44.884,0,0,0,5.4,5.251c1.577.947,5.048,3.47,9.149.631l-.048-.041A3.954,3.954,0,0,0,276.358,732.777Z",
    transform: "translate(-258.026 -723.637)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.454,625.061l-.631,9.056-3.1,44.087,3.1,5.128s.631,4.1-4.1,3.786c-1.408-.094-6.393-6.433-6.393-6.433l.72-2.905-3.509-33.1.032-9.614-1.678-10.676Z",
    transform: "translate(-251.894 -624.388)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(113.838 403.029)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M185.411,719.656a4.04,4.04,0,0,0-3.895.474,4.092,4.092,0,0,0-1.536,3.453,7.46,7.46,0,0,0,.805,2.473c1.887,4.089,7.178,13.335,13.249,11.64a4.56,4.56,0,0,0,3-5.618C196.253,728.612,190.274,721.186,185.411,719.656Z",
    transform: "translate(-179.968 -719.377)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.382 343.02)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M217.286,613.2l-1.057,13.039-25.6,46.086s3.679,6.427,1.346,6.986-9.176-1.389-9.191-8.647c2.691-8.79,13.27-38.638,13.27-38.638l4.954-7.7-.073-14.475Z",
    transform: "translate(-182.787 -609.851)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.94 200.675)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M192.953,452.1c-.2-3.844,1.027-13.873,2.29-17.467,4.6-13.1,5.493-19.562,5.493-30.228s-.9-44.483-.9-44.483l8.77-9.868,23.543.553,10.943,3.609s2.317,42.547,2.975,56.26c.47,9.786,1.149,18.261,2.044,29.6a257.4,257.4,0,0,1-1.367,53.588s-.865,9.206-1.253,10.013c-.051.274-.08.421-.08.421H201.432v-15.8q-2.189-7.607-4.172-15.273C195.572,466.531,193.328,459.23,192.953,452.1Z",
    transform: "translate(-192.931 -350.049)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120.29 200.763)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M196.52,352.741l-1.552,6.942s4.928,37.994,5.231,44.79-8.455,33.957-8.455,33.957l36.281,4.732s5.336-29.006,6.872-43.415-20.415-49.537-20.415-49.537Z",
    transform: "translate(-191.744 -350.21)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(159.56 201.394)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M270.461,352.939l7.4,3.513s-1.041,43.3.857,54.295c1.157,6.7,5.663,28.411,5.663,28.411l-11.716,4.01s-7.213-27.153-8.646-41.563.128-50.243.128-50.243Z",
    transform: "translate(-263.418 -351.362)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.143 162.017)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.315 9.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M267.29,312.467c.962,3.72-1.245,7.395-3.177,10.532-.789,1.282-2.011,3.065-.994,4.528,1.14,1.638,3.971,1.31,5.216.085a7.62,7.62,0,0,0,1.686-3.181c1.681-5.123,4.028-12.3,3.569-17.686-.368-4.319-5.664-11.987-11.12-9.244a5.667,5.667,0,0,0-2.169,2.354,4.452,4.452,0,0,0-.7,1.752c-.258,2.5,2.154,3.144,3.738,4.488A12.628,12.628,0,0,1,267.29,312.467Z",
    transform: "translate(-259.581 -296.924)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.958 12.942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M246.34,328.629a11.369,11.369,0,0,0,8.319-6.076,20.422,20.422,0,0,0,1.955-10.034c-.213-11.449-15.394-12.085-21.3-3.857C230.174,315.831,235.746,329.975,246.34,328.629Z",
    transform: "translate(-233.378 -303.114)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.76,303.386c-.125,1.386-.831,2.856-1.025,4.281-.358,2.622.229,6.024-.73,8.42a16.147,16.147,0,0,1-7.872-3.856c-2.015-1.866-1.652-4.64-2.1-7.388a35.4,35.4,0,0,1-.8-7.669c.795-14.08,14.846-21.781,27.226-15.429,4.683,2.4,6.731,8.51,3.287,12.523-3.705,4.316-11.234,2.445-15.672,5.647A7.573,7.573,0,0,0,227.76,303.386Z",
    transform: "translate(-215.203 -279.493)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.129 34.725)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M250.912,345.421l-.555,2.557c-.084.391-.053,1.509-.389,1.777a.9.9,0,0,1-.666.09c-.658-.081-6.55-.831-6.486-1.205a20.659,20.659,0,0,1,.678-2.948c.253-.775.35-2.234.817-2.822a10.614,10.614,0,0,0,3.214,1.442q1.706.484,3.429.911Z",
    transform: "translate(-242.816 -342.871)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(171.131 165.475)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M284.536,325.854l24.686,2.1-5.53-42.15,9.011.057,13.221,44.186-4.591,13.92-34.8,3.114Z",
    transform: "translate(-284.536 -285.804)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(231.327 254.816)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M398.636,456.781l-4.232-1.16,3.058-6.144,5.292-.611,2.747,3.606Z",
    transform: "translate(-394.404 -448.866)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(447.978 170.418)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.077 19.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M937.484,338.336a17.36,17.36,0,0,1,2.368-8.1,21.379,21.379,0,0,0-1.9,7.571c-.175,4.017,1.294,8.266,4.512,10.706l.056.041q-.364.919-.727,1.838l-3.593-.145c-.513.111-1.274.273-2.228.5a14.315,14.315,0,0,0,1.552-2.546C939.445,344.137,937.358,342.362,937.484,338.336Z",
    transform: "translate(-935.976 -330.233)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.028 30.922)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M973.948,351.262a5.288,5.288,0,0,1-.272,2.582,2.626,2.626,0,0,1-.7,1.1,13.087,13.087,0,0,1-1.373.754c-1.8,1.2-1.111,3.8-1.392,5.57a10.027,10.027,0,0,1-.364,1.469l-1.593-2.231-6.818-.276c0-.019.008-.037.013-.056C966.482,359.708,971.371,355.943,973.948,351.262Z",
    transform: "translate(-961.439 -351.262)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.786)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M798.771,326.128l-2.944-2.491-3.814,1.217-2.188,3.185,1,2.719,3.1,1.8-1.176.314.215.959,4.864,2.216c1.17-1.219,5.113-2.155,5.739-2.808l-3.253-2.8Z",
    transform: "translate(-789.824 -323.637)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.851 240.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M967.959,733.175l.108,1.051.358,3.488-6.948,4.239-4.01-3.112,3.3-3.863.306-.187.162.4Z",
    transform: "translate(-957.465 -733.175)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.1 165.045)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M922.732,596.057c7.874.517,15.181.732,20.922.808l-.2,26.923,8.586,47.284-.375.112-6.729,2.016-.162-.4-22.564-55.747-.788-11.366Z",
    transform: "translate(-921.418 -596.057)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.43 162.466)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M902.308,597.727l.4,5.832L900.7,618.338l-2.3,53.339h-.039l-.029-.771-6.866.209-10.836-56.629-.584-23.137c7.445,1.188,15.25,1.972,22.619,2.486Z",
    transform: "translate(-880.042 -591.351)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.696 164.952)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M921.034,595.888l1.365.093-1.314,9.63-.4-5.832Z",
    transform: "translate(-920.68 -595.888)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.837 242.022)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M897.1,736.777l.473-.015,6.866-.209.029.771.1,2.733-7.209,3.728-3.8-3.392Z",
    transform: "translate(-893.561 -736.553)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.042 11.941)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M943.418,344.234l.728-1.838-.056-.041c-3.217-2.44-4.687-6.689-4.512-10.706a21.382,21.382,0,0,1,1.9-7.571,16.763,16.763,0,0,1,2.934-3.734c2.072-1.963,4.875-3.522,7.613-3.427,1.113.039.65.907,2,.221a2.406,2.406,0,0,0,.61-.519c.2.216.333.368.371.407a20.035,20.035,0,0,0,4.271,2.962,7.449,7.449,0,0,1,3.056,7.59c-.233,1.227-.749,2.49-.454,3.666a10.708,10.708,0,0,0,1.6,2.626,4.735,4.735,0,0,1,.584,1.731c-2.577,4.681-7.466,8.446-12.5,8.908,0,.018-.009.037-.013.055-.067.3-.136.594-.22.884-.368,1.29-1.246,2.652-2.59,2.748a4.073,4.073,0,0,1-1.781-.421l-3.456-1.4a.937.937,0,0,1-.585-.453.922.922,0,0,1,.086-.645Q943.211,344.757,943.418,344.234Z",
    transform: "translate(-939.563 -316.619)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.106)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M897.213,301.764c2.724-.164,5.132,1.431,7.347,2.969.394-2.68,2.972-4.526,5.445-5.249s5.077-.718,7.5-1.665c2.907-1.137,5.778-3.651,8.665-2.832,2.6.737,4.22,3.9,5.836,6.7l.127-.135a13.06,13.06,0,0,1,4.2-3.2c5.183-2.142,4.588,4.327,8.572,3.984.961-.083,1.774-.843,2.681-1.243a5.66,5.66,0,0,1,5.153.775,36.878,36.878,0,0,0,4.533,2.889c1.464.618,3.12.771,4.485,1.591,2.051,1.231,1.63,3.457,1.995,5.486.4,2.246,1.021,5.272,2.235,7.136a20.818,20.818,0,0,0,3.365,3.317,5.187,5.187,0,0,1,1.87,4.3c-.23,1.591-1.491,2.881-1.853,4.452-.5,2.348-.241,3.617-1.288,5.946a7.4,7.4,0,0,1-2.189,3.2c-1.388.963-3.158.71-4.681.249s-3.076-1.1-4.676-.786c-3.471.681-3.28,4.11-4.527,6.8a8.232,8.232,0,0,1-4.021,3.95,7.531,7.531,0,0,1-6.787-.024c-3.063-1.708-4.452-5.682-3.833-9.346a28.263,28.263,0,0,1,1.2-3.825,10,10,0,0,0,.364-1.469c.28-1.773-.411-4.369,1.392-5.57a13.077,13.077,0,0,0,1.374-.754,2.628,2.628,0,0,0,.7-1.1,5.284,5.284,0,0,0,.272-2.582,4.737,4.737,0,0,0-.584-1.731,10.7,10.7,0,0,1-1.6-2.625c-.3-1.176.22-2.439.453-3.666a7.448,7.448,0,0,0-3.056-7.59,20.043,20.043,0,0,1-4.271-2.962c-.038-.039-.174-.191-.371-.407a2.408,2.408,0,0,1-.61.519c-1.346.685-.883-.182-2-.221-2.738-.1-5.542,1.465-7.613,3.427a16.759,16.759,0,0,0-2.934,3.734,17.358,17.358,0,0,0-2.368,8.1c-.127,4.026,1.96,5.8.043,9.858a14.294,14.294,0,0,1-1.552,2.546,13.141,13.141,0,0,1-6.352,4.629c-.281,0-.561-.012-.839-.034a10.7,10.7,0,0,1-3.985-1.136,11.93,11.93,0,0,1-6.247-8.185c-.242-1.181-.358-2.488-1.134-3.342-.625-.687-1.577-.953-2.216-1.625-2.658-2.794,2.416-7.865,1.273-11.7-.722-2.427-3.708-3.374-4.356-5.829C891.614,304.765,894.489,301.928,897.213,301.764Z",
    transform: "translate(-892.225 -294.825)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.656 23.893)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M796.5,341.269c.2-.037,9.406,14.741,15.822,21.96,5.856,6.591,23.786,16.514,30.478,22.255-2.118,7.449,1.051,44.355-.525,51.839-10.038,47.635-8.4,38.123-8.4,38.123,2.716.586,5.533,1.1,8.4,1.56,7.445,1.188,15.25,1.973,22.619,2.486l1.365.093c7.874.517,15.181.731,20.922.807,7.44.1,12.252-.033,12.252-.033L916.1,386.077,904.7,370.128a7.53,7.53,0,0,1-6.787-.024c-3.063-1.708-4.452-5.682-3.833-9.345a28.311,28.311,0,0,1,1.2-3.825l-1.593-2.231-6.818-.276c-.067.3-.136.594-.22.884-.368,1.29-1.246,2.652-2.59,2.748a4.075,4.075,0,0,1-1.781-.421l-3.456-1.4a.937.937,0,0,1-.585-.453.92.92,0,0,1,.086-.645q.207-.524.414-1.047l-3.592-.145c-.513.111-1.274.273-2.228.5a13.14,13.14,0,0,1-6.352,4.629c-.281,0-.561-.012-.839-.034a10.7,10.7,0,0,1-3.985-1.136,11.781,11.781,0,0,1-3.322-2.515c-7.806.335-20.38,5.229-27.027,1.219-2.165-1.306-25.029-18.09-24.486-18.175,0,0-9.258,2.626-10.149,2.787Z",
    transform: "translate(-796.496 -338.434)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(349.467 20.77)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "q",
    cx: 72.193,
    cy: 72.201,
    rx: 72.193,
    ry: 72.201,
    transform: "matrix(0.716, -0.698, 0.698, 0.716, 0, 100.755)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.549 48.55)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M698.638,163.686a53.543,53.543,0,1,0,53.7-53.38A53.55,53.55,0,0,0,698.638,163.686Z",
    transform: "translate(-698.638 -110.307)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.223 53.223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "q",
    cx: 34.555,
    cy: 34.559,
    rx: 34.555,
    ry: 34.559,
    transform: "translate(0 48.606) rotate(-44.694)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.576 87.576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M769.868,196.008a14.517,14.517,0,1,0,14.559-14.472A14.519,14.519,0,0,0,769.868,196.008Z",
    transform: "translate(-769.868 -181.536)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(466.143 230.618)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M914.2,441.493l2.791-6.191,23.133,10.246L924.6,450.469l6.758,14.512L908.23,454.735l2.8-6.217-70.916-30.579-2.806,6.216-14.332-17.8,23.113-1.654-2.806,6.216Z",
    transform: "translate(-822.979 -404.7)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(115.827 40.818)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M1034.382,482.143l.03-.06h0Zm1.3-2.883.029-.06h0Z",
    transform: "translate(-1034.382 -479.2)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.202 169.05)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48.363)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M590.767,380.6l-10.235,39.389L554.79,431.773l1.861,9.925,28.534-6.2L608.343,398.9Z",
    transform: "translate(-554.79 -380.598)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.085 137.066)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M609.7,542.5v40.94L620.864,649.5H631.72l-2.481-58.309,7.134-47.764Z",
    transform: "translate(-609.699 -542.496)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.779 36.032)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M611.008,370.424l21.062-12.332s11,18.574,24.921,48.9,6.837,72.718,6.837,72.718-53.244-4.338-63.812-4.78L604,414.992Z",
    transform: "translate(-600.016 -358.092)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.604 129.834)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M639.849,538.827l15.322,104.838h11.58l-.216-57.184,9.531-57.184Z",
    transform: "translate(-639.849 -529.297)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.808)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.48 12.579)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M604.595,321.735c6.566-.517,11.819-6.779,18.411-6.435,4.286.224,8.131,3.406,10.035,7.365a10.527,10.527,0,0,1,1.137,5.936,10.061,10.061,0,0,1-1.365,3.664,14.3,14.3,0,0,1-3.4,3.9,25.832,25.832,0,0,0,3.344,3.262l-8.455,4.816-2.775-4.857a13.858,13.858,0,0,1-2.739,0,15.682,15.682,0,0,1-12.674-9.852A30.467,30.467,0,0,1,604.595,321.735Z",
    transform: "translate(-604.595 -315.287)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M595.411,313.063,615.12,307.6l6.245,14.737,4.979-5.367-6.766-24.643-28.423,3.731-11.164,9.075,1.624,7.132,12.1,5.7Z",
    transform: "translate(-579.992 -292.329)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.887 37.812)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M627.47,365.229l23.719-3.888s8.346,10.13,22.264,40.451,6.837,72.718,6.837,72.718-49.435-15.666-60-16.108l.176-48.605Z",
    transform: "translate(-620.288 -361.341)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.647 42.805)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M627.463,415.061c-.361,4.425-.709,9.4.794,13.421,0,0,3.692,5.416,3.9,5.139-.018-.188,2.758-3.3,3.348-5.392,1.007-3.571.695-7.786.149-11.556-1.935-13.377-4.789-26.725-4.553-40.239,2.506-1.2,4.464-3.481,2.427-5.979-4.819,2.725-3.6,14.324-3.993,19.2Q628.5,402.357,627.463,415.061Z",
    transform: "translate(-627.151 -370.455)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.636 244.069)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M622.144,737.792l-9.615,4.278v2.674l10.855.8,9.925-1.337-.31-6.417Z",
    transform: "translate(-612.529 -737.792)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.897 244.069)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M663.582,737.792l-5.211,5.732-3.387,3.126,3.127,3.126,8.858-1.824,7.555-6.513-1.3-3.647Z",
    transform: "translate(-654.985 -737.792)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.513 37.507)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M680.307,402c-13.991-30.794-22.381-41.219-22.381-41.219l-23.7,4.021-.019.122c.7,1.239,1.417,2.467,2.072,3.731a93.654,93.654,0,0,1,6.374,15.582,169.355,169.355,0,0,1,5.762,29.177,196.537,196.537,0,0,1,1.4,28.369,193.4,193.4,0,0,1-4.625,37.1c21.516,1.105,46.843,2.43,46.843,2.43S694.3,432.8,680.307,402Z",
    transform: "translate(-634.208 -360.784)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(213.704 166.308)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.305 241.388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M463.563,727.894l7.094,5.025,2.365,3.843a27.553,27.553,0,0,1-4.138,1.478c-1.478.3-13.005-1.478-13.005-1.478v-6.8Z",
    transform: "translate(-455.878 -727.894)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.844 243.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M414.363,732.966l3.842,3.842s3.252,5.321,1.774,5.321-9.458.887-10.05,0-5.025-3.843-5.616-4.434-.318-5.774-.318-5.774Z",
    transform: "translate(-403.933 -731.921)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.515 123.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M417.786,530.082l-5.025,50.544-8.572,53.2H393.844l-1.182-55.569s-10.345-50.544-11.233-65.619Z",
    transform: "translate(-381.43 -512.643)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.649 118.131)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M467.124,526.579l-8.867,101.679H447.616l-3.251-52.022-6.108-46.057,23.252-27.246Z",
    transform: "translate(-438.256 -502.932)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 36.986)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M428.4,360.16s-12.982-9.783-26.933-2.841-24.291,23.634-31.472,62.478-10.59,43.376-4.875,44.825,21.038-3.58,26.044-2.467,38.39,9.259,48.716.737-7.414-26.236-8.571-53.9S439.229,369.555,428.4,360.16Z",
    transform: "translate(-362.239 -354.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.6 37.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M450.279,356.124l-3.844-.433-.969,3.788,8.121,41.389,5.713-16.543.29-25.234Z",
    transform: "translate(-445.466 -355.691)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.261 40.401)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M462.1,389.782c.2-1.557.341-2.957.384-4.105.293-7.928-3.738-18.939-3.738-18.939a40.8,40.8,0,0,1,.171-4.228l-4.512-1.447-.431,4.873,1.682,2.388s2.052,19.286,1.022,26.741c-.108.782-.241,1.583-.391,2.392l1.146,5.839Z",
    transform: "translate(-453.974 -361.063)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.915 98.046)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M445.047,466.274l-17.258,41.671,10.957,3.689,7.737,1.959.621-39.785Z",
    transform: "translate(-427.789 -466.274)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.668)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.006 13.555)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M455.81,340.6l-7.619-2.285a39.72,39.72,0,0,1,1.631-6.123c-2.01-1.18-4.283-2.8-4.219-5.135a6.561,6.561,0,0,1,.546-2.123c1.079-2.837,1.279-6.022,3.239-8.511.649-.825.764-1.99,1.485-2.752,1.267-1.338,3.278-1.639,5.12-1.6a16.39,16.39,0,0,1,12.407,5.713,7.185,7.185,0,0,1,1.634,3.33c.29,1.907-.57,3.78-1.408,5.518q-1.16,2.406-2.32,4.812c-.89,1.845-2.058,3.911-4.073,4.275-1.07.193-2.222-.149-3.235.248C457.212,336.663,456.966,339.066,455.81,340.6Z",
    transform: "translate(-445.602 -312.063)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M473.661,295.867a7.791,7.791,0,0,1-1.62-.919c-1.655-1.281-2.548-3.235-4.331-4.495a18.663,18.663,0,0,0-13.017-2.937c-4.156.629-9.436-.061-13.335,1.211a10.569,10.569,0,0,0-4.238,2.812,15.93,15.93,0,0,0-3.267,16.526,22.819,22.819,0,0,0,1.835,3.541c1.446,2.346,3.16,5.229,5.538,6.457.5-2.244-.168-9.759,1.925-11.27,2.776-2,6.942-.88,9.869.16,3.487,1.239,6.718.837,10.236,1.917,1.792.551,3.751,1.434,5.438.619a32.575,32.575,0,0,0,7.72-6.052,4.907,4.907,0,0,0,.27-5.237A5.435,5.435,0,0,0,473.661,295.867Z",
    transform: "translate(-432.814 -287.324)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.896 37.458)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M424.3,355.691l-12.716,2.171-13.026,21.09,35.357,42.181,36.908,10.235,4.032-9.615-33.807-19.229-20.78-37.839Z",
    transform: "translate(-398.553 -355.691)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(306.213 270.503)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M534.484,477.5l2.144,1.186-3.412,7.754-2.134-.828Z",
    transform: "translate(-531.082 -477.497)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(316.721 269.058)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M552.83,474.859l-2.569.77,1.861,8.684,2.331-.8Z",
    transform: "translate(-550.261 -474.859)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.986 269.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M538.916,477.87l3.1-2.171,4.342,2.171,1.861,1.241v4.652l-4.342,1.551-7.735-1.142Z",
    transform: "translate(-536.143 -475.699)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(311.759 269.208)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M546.166,475.753l-2.791-.62-2.171.31.62,4.342,1.861-.31v-3.6l.62-.434,2.006.985Z",
    transform: "translate(-541.204 -475.133)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(355.549 209.569)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.077 0.064)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M748.03,572.362a8.834,8.834,0,0,0-6.79-8.575,8.24,8.24,0,0,0,.2-2.439,9.746,9.746,0,0,0-1.223-3.907c-1.67-3.119-4.849-5.075-7.832-6.976-3.188-2.033-6.379-4.233-8.589-7.3-4.208-5.84-.736-12.369-3.138-18.6-1.718-4.458-4.44-5.677-7.964-6.171l-.39-3.512c9.992.238,17.521.171,18.269-.525.648-.6,1.272-5.2,1.466-12.346l12.828-2.932c4.08-.978-2.547-45.846-3.456-49.922A86.667,86.667,0,0,0,709.742,399.4,89.467,89.467,0,0,0,685.311,386c-1.188-.428-8.8-1.06-9.132-1.51l-13.062-17.53c-.685-.919-2.249-.645-2.281.4l-.631,19.921a103.476,103.476,0,0,0-28.114,11.976l4.289,9.4c3,6.577-15.113,36.528-15.113,36.528l12.871,18.243s11.395.09,12.214-5.576a25.236,25.236,0,0,1,4.368-10.326l32.273-6.4-.939,5.405-32.336,47.485a2.418,2.418,0,0,0-.216,2.331l6.436,14.678a2.413,2.413,0,0,0,2.073,1.442c2.726.156,8.98.507,16.732.9l-.406,4.346c-3.433.617-6.313,2.246-7.821,6.192-2.381,6.242,1.112,12.759-3.078,18.613-2.2,3.075-5.384,5.285-8.566,7.328-2.977,1.912-6.15,3.877-7.81,7a9.248,9.248,0,0,0-1.054,7.08,8.835,8.835,0,0,0-6.852,8.62v.179a8.837,8.837,0,0,0,8.851,8.822l91.2-.147a8.837,8.837,0,0,0,8.822-8.851Z",
    transform: "translate(-621.267 -366.399)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(53.478 146.958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.872,634.62l37.556,1.522.39,3.512-37.945-3.774Z",
    transform: "translate(-718.872 -634.62)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ab",
    transform: "translate(42.943 30.66)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M767.47,527.307c.855-.2-2-21.947-2.3-24.144a159.791,159.791,0,0,0-5.157-24.384c-4.928-16.282-13.2-32.009-26.753-42.656-9.4-7.382-21.253-13.889-33.61-13.759a88.392,88.392,0,0,1,27.846,3.945c15.743,5.12,26.3,20.131,33.69,34.14a118.542,118.542,0,0,1,12.931,42.127c.184,1.665,2.828,22.412,1.743,22.815Z",
    transform: "translate(-699.645 -422.359)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M647.947,581.549a8.916,8.916,0,0,1-8.915-8.886v-.179a8.849,8.849,0,0,1,6.836-8.667,9.4,9.4,0,0,1,1.078-7.064c1.613-3.038,4.626-4.97,7.541-6.839l.291-.186c3.1-1.993,6.322-4.2,8.548-7.311,2.36-3.3,2.271-6.737,2.176-10.376-.071-2.706-.143-5.5.894-8.222,1.343-3.516,3.829-5.494,7.821-6.224l.4-4.231c-7.522-.382-13.667-.726-16.666-.9a2.469,2.469,0,0,1-2.129-1.481l-6.436-14.678a2.468,2.468,0,0,1,.221-2.393l32.328-47.474.92-5.3-32.158,6.38a25.352,25.352,0,0,0-4.341,10.277c-.8,5.568-11.779,5.632-12.246,5.632h-.065l-.019-.026-12.895-18.277.021-.036c.181-.3,18.064-30,15.11-36.468l-4.312-9.445.045-.03a104.469,104.469,0,0,1,28.088-11.972l.629-19.873a1.116,1.116,0,0,1,1.209-1.02h0a1.462,1.462,0,0,1,1.188.584l13.062,17.53a26,26,0,0,0,4.805.815,35.788,35.788,0,0,1,4.3.673A89.444,89.444,0,0,1,709.719,399.3,87.217,87.217,0,0,1,729.8,421.213a86.207,86.207,0,0,1,11.609,27.874c.845,3.789,7.623,48.987,3.408,50l-4.443,1.015-1.53.35-6.807,1.556c-.186,6.73-.782,11.686-1.485,12.341-.482.449-3.538.667-9.343.667-2.473,0-5.466-.041-8.9-.122l.376,3.389c3.543.5,6.254,1.761,7.966,6.2,1.047,2.715.982,5.513.921,8.22-.083,3.64-.162,7.078,2.209,10.369,2.237,3.1,5.461,5.3,8.572,7.284l.293.186c2.919,1.859,5.938,3.782,7.561,6.813a9.765,9.765,0,0,1,1.231,3.934,8.338,8.338,0,0,1-.185,2.4,8.864,8.864,0,0,1,6.778,8.622v.179a8.911,8.911,0,0,1-8.886,8.915Zm35.062-140.569-.964,5.522-32.336,47.485a2.338,2.338,0,0,0-.21,2.269l6.436,14.678a2.339,2.339,0,0,0,2.018,1.4c3.007.172,9.179.517,16.732.9l.067,0-.417,4.462-.048.009c-3.972.713-6.442,2.668-7.772,6.151-1.028,2.695-.956,5.48-.885,8.173.091,3.5.186,7.121-2.2,10.455-2.24,3.13-5.468,5.344-8.583,7.344l-.291.187c-2.9,1.86-5.9,3.783-7.5,6.791a9.248,9.248,0,0,0-1.049,7.033l.019.065-.066.015a8.721,8.721,0,0,0-6.8,8.557v.178a8.785,8.785,0,0,0,8.772,8.759l91.212-.147a8.783,8.783,0,0,0,8.759-8.787v-.179a8.737,8.737,0,0,0-6.74-8.512l-.062-.014.015-.062a8.221,8.221,0,0,0,.2-2.421,9.629,9.629,0,0,0-1.216-3.881c-1.607-3-4.611-4.915-7.517-6.765l-.293-.187c-3.121-1.991-6.357-4.194-8.607-7.317-2.4-3.325-2.313-6.946-2.233-10.447.061-2.694.125-5.48-.912-8.171-1.7-4.4-4.391-5.636-7.914-6.129l-.049-.007-.4-3.635.073,0c3.462.082,6.479.124,8.968.124,5.691,0,8.805-.213,9.256-.632.549-.511,1.235-4.578,1.446-12.3l0-.049,8.433-1.927,4.444-1.016c1.645-.394,1.678-8.822.093-23.729-1.242-11.679-3.132-24.029-3.6-26.115a86.07,86.07,0,0,0-11.591-27.833,87.1,87.1,0,0,0-20.05-21.88A89.3,89.3,0,0,0,685.226,386a37.063,37.063,0,0,0-4.27-.667c-2.92-.372-4.706-.615-4.892-.865L663,366.943a1.337,1.337,0,0,0-1.085-.533.993.993,0,0,0-1.08.9l-.632,19.968-.046.013a104.806,104.806,0,0,0-28.05,11.937l4.266,9.345c1.254,2.747-.91,9.739-6.431,20.786-3.961,7.924-8.318,15.191-8.663,15.766L634.108,463.3c.487,0,11.328-.07,12.117-5.522a25.51,25.51,0,0,1,4.38-10.356l.015-.02.024,0Z",
    transform: "translate(-621.127 -366.282)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.458 210.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.494 124.489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M172.441,605.783l-2.941,6.365a4.075,4.075,0,0,1-5.381,2.056l-16.309-7.537a4.073,4.073,0,0,1-1.921-5.43l2.941-6.365Z",
    transform: "translate(-145.498 -594.872)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.171 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M167.739,393.869c10.348-22.392,36.442-32.362,58.283-22.269s31.159,36.427,20.811,58.819a45.275,45.275,0,0,1-16.1,18.821h0c-19.74,13.819-29.6,28.477-29.6,28.477l-19.9-9.2-19.9-9.2s4.773-17.009,2.5-41h0A45.276,45.276,0,0,1,167.739,393.869Z",
    transform: "translate(-161.334 -367.66)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 91.454)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M190.725,553.392,178.23,580.431a2.2,2.2,0,0,1-2.893,1.145L138.516,564.56a2.2,2.2,0,0,1-1-2.945l12.494-27.038Z",
    transform: "translate(-137.296 -534.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.171 18.942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M171.95,402.233c.741,24.775,5.876,64.893,29.253,91.014l-.069.1-19.9-9.2-19.9-9.2s4.773-17.009,2.5-41h0a45.276,45.276,0,0,1,3.9-24.459A45.961,45.961,0,0,1,171.95,402.233Z",
    transform: "translate(-161.334 -402.233)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.743 5.569)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M259.931,435.362c9.033-19.548.9-42.539-18.169-51.351a37.655,37.655,0,0,0-33.754,1.172,37.865,37.865,0,0,1,38.143-3.92c19.068,8.811,27.2,31.8,18.169,51.351a39.449,39.449,0,0,1-17.128,18.27A39.575,39.575,0,0,0,259.931,435.362Z",
    transform: "translate(-208.008 -377.825)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.338 37.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M197.314,502.823l28.773-49.685-9.305,2.606-1.453-12.151-10.135,6.43-4.05-8.471-19.21,54.163-2.043-.944,20.961-59.1,5.294,11.074,11-6.976,1.564,13.076,12.1-3.39-31.453,54.311Z",
    transform: "translate(-179.891 -435.672)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.338 71.551)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.423 26.744)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M216.6,549.172l-2.869,4.955-2.043-.944,3.544-6.12Q215.9,548.126,216.6,549.172Z",
    transform: "translate(-211.69 -547.063)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M189.843,501.707l-7.909,22.3-2.043-.943,8.8-24.813Q189.244,499.983,189.843,501.707Z",
    transform: "translate(-179.891 -498.251)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.375 98.167)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.928 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 5.5,
    height: 44.854,
    transform: "translate(0 4.993) rotate(-65.198)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.663)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 5.5,
    height: 44.854,
    transform: "translate(0 4.993) rotate(-65.198)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 91.454)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.682 11.706)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M164.236,570.113l-18.395-8.5,2.621-5.67,11.346,5.243A83.086,83.086,0,0,0,164.236,570.113Z",
    transform: "translate(-145.841 -555.943)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M154.835,541.29l3.1-6.713.641.3c.744,3.3,1.6,6.411,2.56,9.33Z",
    transform: "translate(-154.835 -534.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 22.37)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M175.338,600.034l-36.822-17.015a2.2,2.2,0,0,1-1-2.946l2.157-4.668,26.587,12.286a65.106,65.106,0,0,0,11.669,11.677A2.164,2.164,0,0,1,175.338,600.034Z",
    transform: "translate(-137.296 -575.405)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.303 6.713)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M161.97,557.066l-11.346-5.243,2.307-4.993,6.3,2.912Q160.5,553.62,161.97,557.066Z",
    transform: "translate(-150.624 -546.83)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.375 17.377)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M168.217,583.571,141.63,571.285l2.307-4.993,18.395,8.5A74.922,74.922,0,0,0,168.217,583.571Z",
    transform: "translate(-141.63 -566.292)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.494 128.355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M147.043,601.927c2.5,6.656,10.66,12.092,13.411,13.773l-12.644-5.843a4.073,4.073,0,0,1-1.921-5.43Z",
    transform: "translate(-145.498 -601.927)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(411.286 223.013)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.375 6.866)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M725.366,407.666l2.814,7.975,5.608-.754-1.128-5.508,1.39-4.311-6.1-1.716Z",
    transform: "translate(-725.366 -403.352)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M725.418,390.821l-2.562,7.489,11.435,2.549v-4.4Z",
    transform: "translate(-722.856 -390.821)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.355 210.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M942,368v35.613l12.244-35.539-3.771,3.357Z",
    transform: "translate(-942 -368)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.199 255.871)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M227.757,450.9l4.434-.111-.1,2.649,4.66,3.437-4.6,2.994-5.894-3.051Z",
    transform: "translate(-226.256 -450.791)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.079 241.162)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.663,424.109s-2.386-.682-10.283.734l1.6,11.112,40.934,8.944,3.884-6.033Z",
    transform: "translate(-149.38 -423.945)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(529.41 251.473)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M939.338,449.875l-.887-3.754,2.813-2.849,3.831-.508,1.972,2.122.2,3.575.813-.906.757.626-.228,5.34c-1.616.491-4.237,3.582-5.1,3.845l-1.019-4.167Z",
    transform: "translate(-938.45 -442.764)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.328 260.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M954.222,500.2l-12.271-38.126,8.245-1.985,15.889,33.994Z",
    transform: "translate(-941.951 -460.089)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupeu476);
export default __webpack_public_path__ + "static/media/Groupeu476.84079c04b20bf8162034891cba11a325.svg";
export { ForwardRef as ReactComponent };